/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  // v87: campanha WhatsApp ao vivo pode levar IMAGEM (multipart). audience
  // vai como JSON string no multipart (o controller reconverte).
  create(data) {
    if (!data.file) return axios.post(this.url, { campaign: data });
    const form = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      if (key === 'audience') form.append('campaign[audience]', JSON.stringify(value));
      else form.append(`campaign[${key}]`, value);
    });
    return axios.post(this.url, form);
  }
}

export default new CampaignsAPI();
